module.exports = __webpack_public_path__ + "assets/img/gandhi_jafta.80aa7044.jpeg";